const PAYMENT_DETAILS_COMPONENT_TYPE = 'PaymentDetails';
export default PAYMENT_DETAILS_COMPONENT_TYPE;
